import PropTypes from 'prop-types';
import { memo } from 'react';
import OptionsList from '../../../../Filters/OptionsList';
import useContentSourceFilter from '../../../../../hooks/useContentSourceFilter'; // Adjust path as needed

const ContentSourceFilter = ({ tripId }) => {
  const {
    doTakeHotelContentSourceInput, contentSourceOptions, selectedValues, handleSourceChange,
  } = useContentSourceFilter(tripId);

  return (
    doTakeHotelContentSourceInput
    && contentSourceOptions.length > 0 && (
      <div className="pt-3">
        <p className="font-extrabold text-black -ml-1">Content Source</p>
        <OptionsList
          options={contentSourceOptions}
          selectedValues={selectedValues}
          onChange={handleSourceChange}
        />
      </div>
    )
  );
};

ContentSourceFilter.propTypes = {
  tripId: PropTypes.string,
};

ContentSourceFilter.defaultProps = {
  tripId: undefined,
};

export default memo(ContentSourceFilter);
